import { Photo } from './order.model';

/**
 * Storage keeps resized copies of every uploaded photo alongside the original,
 * each in its own directory next to it. All paths are derived from the same
 * blobName, so `orders/abc/img.jpg` has its thumbnail at
 * `orders/abc/thumbs/img.jpg` and its web-sized copy at `orders/abc/web/img.jpg`.
 */
export function thumbnailBlobName(photo: Photo): string {
  return resizedBlobName(photo, 'thumbs');
}

export function webBlobName(photo: Photo): string {
  return resizedBlobName(photo, 'web');
}

function resizedBlobName(photo: Photo, directory: string): string {
  const blobName = photo.blobName;
  const lastSlash = blobName.lastIndexOf('/');

  return `${blobName.slice(0, lastSlash + 1)}${directory}/${blobName.slice(lastSlash + 1)}`;
}
